<template>
  <v-app id="ueyes_app">
    <LeftNavMenu />
    <v-main id="main" :class="{ min: checkDisplayPcFromMobile }">
      <router-view></router-view>
      <AutoLogout></AutoLogout>
    </v-main>
		<Footer v-if="mobile" />
  </v-app>
</template>

<script>
import AutoLogout from './AutoLogout.vue';
import LeftNavMenu from './NavMenu';
import Footer from './Footer.vue';
import { isAndroid, isIOS, isMobile } from 'mobile-device-detect';
export default {
  components: {
    LeftNavMenu, AutoLogout, Footer
  },
	data: () => ({
    mobile: false,
		checkDisplayPcFromMobile: true,
  }),
	watch: {
		'$store.state.isPortrait': function(item) {
			console.log('isPortrait change', item);
			if(isAndroid || isIOS) {
				if(this.$store.state.isMobile) {
					if(window.location.href.includes('mobile')) {
						this.checkDisplayPcFromMobile = false;
					} else {
						this.checkDisplayPcFromMobile = true;
					}
				} else {
					if(window.location.href.includes('mobile')) {
						this.checkDisplayPcFromMobile = false;
					} else {
						this.checkDisplayPcFromMobile = true;
					}
				}
			} else {
				this.checkDisplayPcFromMobile = true;
			}
		},
		'$store.state.isMobile': function(item) {
			console.log('isMobile change', item);
			if(isAndroid || isIOS) {
				if(this.$store.state.isPortrait) {
					if(window.location.href.includes('mobile')) {
						this.checkDisplayPcFromMobile = false;
					} else {
						this.checkDisplayPcFromMobile = true;
					}
				} else { // 가로
					if(window.location.href.includes('mobile')) {
						this.checkDisplayPcFromMobile = false;
					} else {
						this.checkDisplayPcFromMobile = true;
					}
				}
			} else {
				this.checkDisplayPcFromMobile = true;
			}
		}
	},
	created() {
		this.mobile = isAndroid || isIOS;
		if(isAndroid || isIOS) {
			if(window.location.href.includes('mobile')) {
				this.checkDisplayPcFromMobile = false;
			} else {
				this.checkDisplayPcFromMobile = true;
			}
		}
	},
	mounted() {
		// 창 크기가 변경될 때마다 너비 조정
    window.addEventListener('resize', this.adjustWidth);

    // 초기에 한번 실행하여 초기 너비 설정
    this.adjustWidth();
	},
	methods: {
    adjustWidth() {
			const element = document.querySelector('#main');
			// dashboard에서는 1350으로 고정해서 흰배경이 나오지 않도록 한다.
			let windowWidth;
			if (window.location.href.includes('dashboard')) {
					windowWidth = 1350;
			} else {
					windowWidth = this.$store.state.isMobile ? window.innerWidth : 1350;
			}
			const windowHeight = window.innerHeight; // 현재 창의 내부 너비
			element.style.minWidth = windowWidth + 'px';
			element.style.minHeight = windowHeight + 'px';
    },
  },
};
</script>

<style lang="scss" scoped>
#main {
  color: white;
  background-color: #222222;
  min-height: 1350px;
  min-width: 300px;
	display: flex;
	justify-content: center; /* 수평 가운데 정렬 */
  /* align-items: center; */
	/* overflow: auto; */
	//padding-bottom: 53px !important;
}
/* .min {
	min-width: 1350px !important;
} */
/* .min {
	min-width: 1350px !important;
}
@media (min-width: 768px) {
  #main {
    min-height: 800px;
  }
} */
</style>